import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { AlertTriangle, Shield, Bug } from "lucide-react";
import * as tests from "./testDefinitions";

export const NegativePathSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Negative Paths & Edge Cases</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={AlertTriangle}
          iconColor="text-yellow-600"
          title="Input Validation"
          tests={tests.validationTests}
          results={testResults.validation}
        />
        
        <TestSubsection
          icon={Shield}
          iconColor="text-red-600"
          title="Security Tests"
          tests={tests.securityTests}
          results={testResults.security}
        />
        
        <TestSubsection
          icon={Bug}
          iconColor="text-orange-600"
          title="Error Handling"
          tests={tests.errorHandlingTests}
          results={testResults.errorHandling}
        />
      </CardContent>
    </Card>
  );
};
